<template>
  <modal
    name="add-link-modal"
    height="auto"
    adaptive
  >
    <div
      class="flex flex-col my-4"
      v-if="canConnectAccounts"
    >
      <div class="mx-4">
        <p
          class="mt-1 mb-3 ml-3 text-xl text-left text-sc-gray-dark"
        >
          {{ $t('message.settings.accountsTab.connectAccount') }}
        </p>
        <div class="mx-3">
          <fintoc-widget
            :entity-id="entityId"
            @onSuccess="successfulConnection()"
          />
        </div>
      </div>
    </div>
    <div
      v-else
      class="flex flex-col m-4 text-xl text-center md:text-2xl text-primary"
    >
      <h1 class="mb-2">
        Contrata un plan para conectar más cuentas.
      </h1>
      <p class="text-base md:text-lg text-primary">
        Hablemos para contarte más.
      </p>
      <p class="text-base md:text-lg text-primary">
        Puedes escribirnos por el chat o agendar una videollamada.
      </p>
      <a
        target="_blank"
        rel="noopener noreferrer"
        :href="calendly"
      >
        <b-button
          class="inline-block px-3 py-1 mt-4 text-sm leading-5 text-center text-white rounded md:mt-8 bg-sc-blue hover:text-white"
        >
          Agendar videollamada
        </b-button>
      </a>
      <div class="fixed bottom-0 right-0 hidden p-3 mb-8 mr-24 bg-white rounded shadow-lg md:block bg-opacity-10">
        <h1>O escríbenos por acá &rarr;</h1>
      </div>
    </div>
  </modal>
</template>
<script>
import fintocWidget from './bank-accounts/fintoc-widget.vue';

export default {
  components: {
    fintocWidget,
  },
  data() {
    return {
      calendly: import.meta.env.VITE_DEFAULT_CALENDLY_LINK,
    };
  },
  props: {
    entityId: {
      type: Number,
      required: true,
    },
    canConnectAccounts: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    show() {
      this.$modal.show('add-link-modal');
    },
    hide() {
      this.$modal.hide('add-link-modal');
    },
    successfulConnection() {
      this.$emit('onSuccess', true);
      this.hide();
    },
  },
};
</script>
